import {links, socials} from './data'
import './footer.css'

const Footer = () => {
  return (
    <footer>
      <div className="container footer__container">
        <ul className='nav__menu'>
          {
            links.map(fLink => <li key={fLink.id}><a href={fLink.link}>{fLink.title}</a></li>)
          }
        </ul>
        <div className="footer__socials">
          {
            socials.map(social => <a key={social.id} href={social.link} target="_blank" rel="noopener noreferrer">{social.icon}</a>)
          }
        </div>
      </div>
      <div className="footer__copyright">
        <small>2026 IntElligence Tech Solutions &copy; All Rights Reserved </small>
      </div>
      
      <div className='privacy-policy'>
      <a className="privacy_policy" href='https://pub-1a559929ef4149c4abff31d55531033a.r2.dev/Privacy-policy.pdf' target='_blank' >Privacy and Policy</a>
      </div>

      <div className='terms'>
      <a className="terms" href='https://pub-1a559929ef4149c4abff31d55531033a.r2.dev/Terms%20and%20Conditions.pdf' target='_blank' >Terms & Conditions</a>
      </div>


    </footer>
  )
}

export default Footer